import { Controller } from "@hotwired/stimulus"

// Only a device that plays carries a resolution and a rotation (GER-8): a
// computer and a router have no surface. The block disappears for those kinds
// so nobody is asked for the resolution of a router — the model asks for one on
// a playing kind either way, so this is the convenience and the validation is
// the rule. The poll interval (GER-36) goes the same way for whatever runs no
// player (GER-31).
export default class extends Controller {
  static targets = ["kind", "surface", "pairable"]
  static values = { playing: Array, pairable: Array }

  connect() {
    this.toggle()
  }

  toggle() {
    const kind = this.kindTarget.value
    this.surfaceTarget.hidden = !this.playingValue.includes(kind)
    this.pairableTarget.hidden = !this.pairableValue.includes(kind)
  }
}
